module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/sa-icon-offline_59b79a5.png";